<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <retencion-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import RetencionCrud from "./RetencionCrud";
    export default {
        name: "Retencion",
        components: {RetencionCrud}
    }
</script>

<style scoped>

</style>

